import { ChatterPost } from './types';

// Demo data until posts are persisted.
export const CHATTER_OPPORTUNITY_SEED_POSTS: Array<ChatterPost> = [
  {
    id: 'seed-commercial-review',
    authorName: 'Sabina Sobczak',
    audience: 'The LuxGroup Only',
    createdAt: '2026-02-10T00:24:00',
    text: '**Commercial Review**\n\nWriter: @Henry Ballard  \nEditor: @Nathaniel Robinson\n\nOffer is ready for commercial review. Please flag anything on inclusions or fine print before we lock copy.',
    likeCount: 0,
    isLikedByMe: false,
    comments: [
      {
        id: 'seed-comment-design',
        authorName: 'Catherine Geard',
        createdAt: '2026-02-11T09:40:00',
        text: 'Thanks so much team! @LE Design Team the new images look great. Is it possible to add a little destination stock imagery please?',
      },
      {
        id: 'seed-comment-actioned',
        authorName: 'Emily Butler',
        createdAt: '2026-04-20T11:12:00',
        text: 'Thanks, actioned!\n\n#UPDATE: Adjusted the inclusions and fine print as discussed and timestamped the change at the top of the section.',
      },
    ],
  },
  {
    id: 'seed-rates-confirmed',
    authorName: 'Alexis Cunningham',
    audience: 'The LuxGroup Only',
    createdAt: '2026-03-15T14:30:00',
    text: 'Rates and inclusions have been confirmed with the property. Flagging for commercial review this week, shout if anything looks off before we lock copy.',
    likeCount: 2,
    isLikedByMe: false,
    comments: [],
  },
  {
    id: 'seed-cost-update',
    authorName: 'Ann-Marie Kerry',
    audience: 'The LuxGroup Only',
    createdAt: '2026-02-05T16:18:00',
    text: 'Updated this record.\n\n**Sell Price (AUD)**  \nA$640.00 to A$669.00',
    likeCount: 0,
    isLikedByMe: false,
    comments: [],
  },
];
